import React from "react";
import Chart from "react-apexcharts";

const VendorTopProductsChart = ({ topProducts = [] }) => {
  // Ensure minimum 3 items
  const filledProducts = [...topProducts];

  while (filledProducts.length < 3) {
    filledProducts.push({
      product_id: null,
      product_name: "N/A",
      total_quantity: 0,
    });
  }

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    xaxis: {
      categories: filledProducts.map((p) => p.product_name),
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "50%",
      },
    },
  };

  const chartSeries = [
    {
      name: "Quantity Sold",
      data: filledProducts.map((p) => Number(p.total_quantity)),
    },
  ];

  return (
    <div className="card p-3">
      <h5 className="mb-3">Top Products</h5>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default VendorTopProductsChart;
